import { toSlugMap } from './toSlugMap';

// The glob pattern must be a literal, so there is one of these modules per set.
export const icons = toSlugMap(
  import.meta.glob('../feather/*.svg', { query: '?react', import: 'default', eager: true })
);
